import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import * as eventKeys from '../lib/events';

export default (el, props) => {
    const $el = $(el);
    const $arrow = $el.find('svg.-arrow');
    const $i = $el.find('svg.-info-i');
    
    let elementheight = $el.height();
    let step = 1;
    let interval = -1;
    
    const reset = () => {
        if (step === 1) {
            TweenLite.set($arrow.get(0), { y: 0 });
            TweenLite.set($i.get(0), { display: 'block', y: elementheight });
        } else {
            TweenLite.set($arrow.get(0), { y: elementheight });
            TweenLite.set($i.get(0), { display: 'block', y: 0 });
        }
    };
    
    const animateStep = () => {
        reset();
        
        if (step === 1) {
            TweenLite.to($arrow.get(0), 0.3, { y: -elementheight, ease: Quart.easeIn, onComplete: () => {
                TweenLite.to($i.get(0), 0.3, { y: 0, ease: Sine.easeOut });
            } });
            
            step = 2;
        } else {
            TweenLite.to($i.get(0), 0.3, { y: -elementheight, ease: Quart.easeIn, onComplete: () => {
                TweenLite.to($arrow.get(0), 0.3, { y: 0, ease: Sine.easeOut });
            } });
            
            step = 1;
        }
    };
    
    const onResize = () => {
        elementheight = $el.height();
    };
    
    const onInformationPanelActivated = () => {
        $el.css({ display: 'block', opacity: 1 });
        elementheight = $el.height();
        reset();
        
        interval = setInterval(() => {
            animateStep();
        }, 2000);
        
        Dispatch.off(eventKeys.INFORMATION_PANEL_ACTIVATED, onInformationPanelActivated);
    };
    
    const init = () => {
        Dispatch.on(eventKeys.INFORMATION_PANEL_ACTIVATED, onInformationPanelActivated, true);
        Viewport.on('resize', onResize);
    };
    
    const destroy = () => {
        clearInterval(interval);
        Dispatch.off(eventKeys.INFORMATION_PANEL_ACTIVATED, onInformationPanelActivated);
        Viewport.off('resize', onResize);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/InfoScrollButtonAnim.js